(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[274],{

/***/ 1965:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programs",
      function () {
        return __webpack_require__(6604);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_SuccessStorySection; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@splidejs/react-splide/dist/js/react-splide.esm.js
var react_splide_esm = __webpack_require__(7677);
;// CONCATENATED MODULE: ./utils/success_stories.json
var success_stories_namespaceObject = JSON.parse('[{"client_image":"https://assets.alanvidyushbaptist.com/success_stories/Kusum.jpg","client_name":"Kusum Melwani","client_review":"I was 93 kgs and I lost 21 kgs to reversed my obesity and other health issues through a quantified nutrition and diet plan along with the appropriate workouts. Nutrition is often the missing key to a fitness journey. Without the proper nutrition, it is challenging to see the best results from workouts. I’m glad today I stand here as a bastion of hope for anyone who’s struggling to lose weight and feels entirely lost. Optimum wellness will significantly improve your health and wellbeing if you are determined to work upon yourself.  It\'s a fantastic and ever-growing platform for achieving optimal health."},{"client_image":"https://assets.alanvidyushbaptist.com/success_stories/Khushi.jpg","client_name":"Khushi Gupta","client_review":"I’ve lost around 30 kgs of weight through a quantified nutrition and a personalised workout plan! I think Optimum Wellness is a great initiative because it is providing evidence based services. I appreciate my story being shared so it can reach more people which really embodies their commitment to spreading the message of fitness to everyone! I highly recommend Optimum Wellness as a source you can trust completely for all your health and wellness requirements. Optimum Wellness is the world’s first and only platform that’s been established to provide research-backed diversified solutions to holistically elevate an individual’s status of wellness"},{"client_image":"https://assets.alanvidyushbaptist.com/success_stories/Anoushka.jpg","client_name":"Anoushka  Rahman","client_review":"I lost 15 kgs in a span of 3 months! I gained a lot of weight and I became really unfit, and there came a time when I had completely given up on myself!  However, thanks to the team for bringing that motivation back in me, changing my nutrition plan for the betterment of my health, thoroughly checking on my routine and my meals every single day, which led to my getting back in shape very quickly! Apart from his vast expertise in nutrition, what they stressed more was mentoring and motivating me regularly, and despite a few hiccups here and there on my end, they never lost faith in me and kept pushing me forward. They really made my \\"impossible\\" turn into \\"possible\\" again, and I\'ll be forever grateful to them for this."},{"client_image":"https://assets.alanvidyushbaptist.com/success_stories/Tanay.jpg","client_name":"Tanay Mondal","client_review":"Losing 10 kgs and getting my abs to reveal and the credit goes to Optimum Wellness who allowed me to transform the way I looked. Fitness and workouts have always fascinated me. But when I decided to up my game, that is when things really came around. The major push behind all of it was a transformation challenge I became a part of. It is when I had this specific goal in mind that started working meticulously towards it and reached out to the team of Optimum Wellness. One thing that I particularly admire in the team is the amount of personal attention they give to their clients! This is hands-down, one of the best teams I’ve worked with!"},{"client_image":"https://assets.alanvidyushbaptist.com/success_stories/Dr%20Sandeep.jpg","client_name":"Dr. Sandeep Gupta","client_review":"I hit a new low in life when I touched 78kgs despite doing gym with my heavy work schedule. I saw Optimum Wellness\' transformation pictures on Instagram, did some research, and got in touch with the team! Initially, I was a little reluctant to follow a long-distance online routine for many obvious reasons like people possessing no scientific knowledge, false promises being made with no positive results occurring, difficulties in communication that may arise and other apprehensions. But the way they responded to my queries was extremely satisfying and being a Doctor myself I could judge that they had a thorough knowledge in this field. I thought this was worth a shot! They\'re not just coaches but also act as great friends."}]');
;// CONCATENATED MODULE: ./components/sections/SuccessStorySection.jsx



var SuccessStorySection = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "successStoryCard",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* Splide */.tv, {
                "aria-label": "My Favorite Images",
                options: {
                    arrows: false,
                    pagination: false,
                    type: "loop",
                    autoplay: true,
                    pauseOnHover: false,
                    resetProgress: false
                },
                children: success_stories_namespaceObject.map(function(story, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_splide_esm/* SplideSlide */.jw, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row m-0 font-gelasio",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-4 m-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: story.client_image,
                                        className: "w-100",
                                        alt: "client",
                                        loading: "lazy"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-8 m-auto",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "ms-sm-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "fo-50 text-white fw-600 hr mfo-32",
                                                children: "SUCCESS STORIES"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "fo-26 text-white fw-600 mt-4",
                                                children: story.client_name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "ps-4 pe-4 ps-lg-5 pe-lg-5 position-relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/quote1.png",
                                                        className: "quote1",
                                                        alt: "quote"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: "/assets/quote2.png",
                                                        className: "quote2",
                                                        alt: "quote"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "ps-2 pe-2 ps-sm-4 pe-sm-4 ps-md-4 pe-md-4 ps-xl-5 pe-xl-5",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "fo-14 text-white mt-4 font-gelasio",
                                                            children: story.client_review
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }, index);
                })
            })
        })
    });
};
/* harmony default export */ var sections_SuccessStorySection = (SuccessStorySection);


/***/ }),

/***/ 6604:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_sections_SuccessStorySection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3419);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _splidejs_react_splide__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7677);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);






var data = {
    "Fat Loss": {
        image: "/assets/program1.png",
        text: "Sustainably achieve and maintain healthy body weight with our weight loss program created by expert coaches to develop long-term healthy eating habits to improve your lifestyle with our support."
    },
    "Muscle Building": {
        image: "/assets/program2.png",
        text: "Suitable for both beginners and Build mass and sculpt your physique to the next level with our muscle-building fitness and nutrition programme."
    },
    Postpartum: {
        image: "/assets/program3.png",
        text: "Secure a smooth and healthy journey of nourishment for yourself and your baby through all your three trimesters by following our clinical nutrition plans."
    },
    "Clinical Conditions": {
        image: "/assets/program4.png",
        text: "Combat lifestyle diseases such as PCOS/PCOD, Renal Disorders, Thyroid, Hypertension, Diabetes, Gastrointestinal and Geriatric disorders with clinical nutrition and fitness plans."
    },
    "Sports Nutrition": {
        image: "/assets/program5.png",
        text: "Enjoy greater strength, endurance, and energy with our sports nutrition and fitness consultation."
    }
};
var Programs = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("Fat Loss"), step = ref[0], setStep = ref[1];
    var splide = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.createRef)();
    var clickHandler = function(s, index) {
        setStep(s);
        splide.current.splide.go(index);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: "https://assets.alanvidyushbaptist.com/optimumwellness_logo.jpg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Select the right program for you! We create highly personalised, tried & tested fitness and nutrition plans that takes into consideration your current BMI, target weight, fitness goals, calorie needs, macronutrient balance, and dietary preferences."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "fitness, health, wellness"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Choose Your Optimum Wellness Program | Personalised Plans for Your Unique Needs"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "ps-3 pe-3 ps-lg-5 pe-lg-5 mt-sm-5 mt-xl-0",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "row m-0 ps-lg-5 pe-lg-5 mb-lg-5",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-sm-4 col-md-5 col-lg-6 m-auto",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: "/assets/program.png",
                                    className: "w-100",
                                    alt: "Programs_page"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-sm-8 col-md-7 col-lg-6 m-auto",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "fo-70 bco fw-700 lg-50 mfo-28",
                                        children: "Choose Your Program"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mt-3 mt-md-5 fo-14 justify d-none d-md-block",
                                        children: [
                                            " ",
                                            "Optimum Wellness shall help decide your health goals and come up with an effective strategy to reach them. When you enroll in one of our programmes, our expert fitness coaches and nutritionists shall mentor you throughout your complete transformation journey. Across this journey, not only shall you reach your goal, but you'll also learn how to maintain your health by making educated decisions regarding food and exercise and inculcating sustainably healthy habits."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "mt-3 mt-md-5 fo-14 justify d-md-none",
                                        children: "Optimum Wellness shall help decide your health goals and come up with an effective strategy to reach them."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "ps-xl-5 pe-xl-5 mt-5 mt-xl-0",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ps-xl-5 pe-xl-5 programs_list d-none d-sm-flex",
                                children: Object.keys(data).map(function(s, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "programs_div cursorPointer ".concat(step == s ? "active" : ""),
                                        onClick: function() {
                                            setStep(s);
                                            splide.current.splide.go(index);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "programs_item fo-16 fw-700 lg-12",
                                            children: s
                                        })
                                    }, index);
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "ps-xl-5 pe-xl-5 programs_list d-sm-none mb-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "programs_div cursorPointer ".concat("Fat Loss" == step ? "active" : ""),
                                        onClick: function() {
                                            clickHandler("Fat Loss", 0);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "programs_item fo-16 fw-700 lg-12 mfo-13",
                                            children: "Fat Loss"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "programs_div cursorPointer ".concat("Muscle Building" == step ? "active" : ""),
                                        onClick: function() {
                                            clickHandler("Muscle Building", 1);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "programs_item fo-16 fw-700 lg-12 mfo-13",
                                            children: "Muscle Building"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "ps-xl-5 pe-xl-5 programs_list d-sm-none mb-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "programs_div cursorPointer ".concat("Postpartum" == step ? "active" : ""),
                                        onClick: function() {
                                            clickHandler("Postpartum", 2);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "programs_item fo-16 fw-700 lg-12 mfo-13",
                                            children: "Postpartum"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "programs_div cursorPointer ".concat("Clinical Conditions" == step ? "active" : ""),
                                        onClick: function() {
                                            clickHandler("Clinical Conditions", 3);
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "programs_item fo-16 fw-700 lg-12 mfo-13",
                                            children: "Clinical Conditions"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "ps-xl-5 pe-xl-5 programs_list d-sm-none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "programs_div w-100 cursorPointer ".concat("Sports Nutrition" == step ? "active" : ""),
                                    onClick: function() {
                                        clickHandler("Sports Nutrition", 4);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "programs_item fo-16 fw-700 lg-12 mfo-13",
                                        children: "Sports Nutrition"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_splidejs_react_splide__WEBPACK_IMPORTED_MODULE_3__/* .Splide */ .tv, {
                                "aria-label": "My Favorite Images",
                                ref: splide,
                                options: {
                                    arrows: false,
                                    pagination: false,
                                    drag: false
                                },
                                children: Object.keys(data).map(function(s, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_splidejs_react_splide__WEBPACK_IMPORTED_MODULE_3__/* .SplideSlide */ .jw, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-center programs_image",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: data[s].image,
                                                        className: "w-100",
                                                        alt: s,
                                                        loading: "lazy"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "text-center programs_text",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "fo-14 justify",
                                                        children: data[s].text
                                                    })
                                                })
                                            ]
                                        })
                                    }, index);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "long-mt",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "ps-xl-5 pe-xl-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "row m-0 ps-lg-5 pe-lg-5 mt-5 mb-5",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-6 col-sm-6 col-md-3 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/assets/program6.png",
                                                className: "w-80 m-auto",
                                                alt: "Programmes"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-20 fw-700 txtco mt-3 mfo-16",
                                                children: "Dedicated Coach"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-14 mt-3 mb-4 mfo-11",
                                                children: "A health coach shall create a custom plan for you based on their expertise and you requirement. They shall be accessible throughout your fitness and wellness journey and offer you motivation if you ever lose sight of your vision."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-6 col-sm-6 col-md-3 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/assets/program7.png",
                                                className: "w-80 m-auto",
                                                alt: "Programmes"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-20 fw-700 txtco mt-3 mfo-16",
                                                children: "Sustainable Results"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-14 mt-3 mb-4 mfo-11",
                                                children: "Our plans shall ensure that you’re empowered with the information and know-how to maintain your results even after your programme has ended. This shall allow you to hold to the health you've attained for an indefinite time period."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-6 col-sm-6 col-md-3 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/assets/program8.png",
                                                className: "w-80 m-auto",
                                                alt: "Programmes"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-20 fw-700 txtco mt-3 mfo-16",
                                                children: "Online Community"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-14 mt-3 mb-4 mfo-11",
                                                children: "Be a part of an awesome global community of health-enthusiasts of around 20000+ individuals working towards the shared common goal of building a world that’s fitter, healthier and happier! Reaching your goals has never been easier!"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "col-6 col-sm-6 col-md-3 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                src: "/assets/program9.png",
                                                className: "w-80 m-auto",
                                                alt: "Programmes"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-20 fw-700 txtco mt-3 mfo-16",
                                                children: "Board of Doctors"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "fo-14 mt-3 mb-4 mfo-11",
                                                children: "Our coaching methodologies are approved by medical health professionals and research scholars who associate with us to work on clinical cases such Diabetes, PCOS, Thyroid, Intolerances, Allergies, Gastrointestinal Disorders etc."
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_sections_SuccessStorySection__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bco fo-34 fw-700 mt-90 mfo-22",
                        children: "Start your health journey with us from today!"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
                        href: "/chooseProgram",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "tablet consultButton pulsating prog",
                                children: "Start Now"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Programs);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [782,774,888,179], function() { return __webpack_exec__(1965); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);